import {useContext} from 'react';

import {StudentQuestionsContext} from '../contexts';

export const useStudentQuestions = () => {
  return useContext(StudentQuestionsContext);
};
